import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import css from './style.scss';
import {
  closePopup,
  getPopupRegistration,
  openPopup,
  Priority
} from 'app/PopupHolder';
import infoGray from 'assets/images/info-gray.svg';
import { useToast } from '../ToastMessage/ToastManager';
import Tooltip from '../../components/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { selectCardList, selectListManagementEnabled, selectPrepaidCredits } from '../../../data/user';
import { appendContacts, getAppendJobEstimate, selectAppendJob } from '../../../data/contacts';
import { propertySkipTrace } from '../../../data/property';
import NewCreditCardDropdown from '../NewCreditCardDropdown';
import DNCPolicyModal from '../DNCPolicyModal';
import { isCardExpired } from "../../../utils/validation";
import { selectLoading } from '../../../data/contacts';
import eyeOpen from 'assets/images/eye-on.svg';
import eyeClosed from 'assets/images/eye-off.svg';
import SVG from 'components/base/SVG';
import InfoAlert from '../InfoAlert';
import AddPaymentPopup from '../../AccountNew/modals/AddPayment';
import CheckboxItem from '../../../components/Checkbox';

const BODY_CLASS_NAME = 'bodyModal';

const SkipTraceModal = ({
  title = 'Skip Trace',
  groups = [],
  closePopup,
  reprocessEnabled,
  contactIds,
  selectedProperties,
  isPropertySkipTrace,
  onSuccess,
  onCancel,

}) => {
  const modalRef = useRef(null);
  const showToast = useToast();
  const cardList = useSelector(selectCardList);
  const dispatch = useDispatch();
  const [reSkipTrace, setReSkipTrace] = useState(reprocessEnabled || false);
  const [selectedCard, setSelectedCard] = useState(cardList[0] || {});
  const [cvv, setCvv] = useState('');
  const [cvvVisible, setCvvVisible] = useState(false);
  const [cvvError, setCvvError] = useState("");
  const [listName, setListName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

   const appendJobState = useSelector(selectAppendJob);
  const appendJob = appendJobState && typeof appendJobState.toJS === 'function' ? appendJobState.toJS() : (appendJobState || {});
  // const appendJob = useSelector(state => selectAppendJob(state).toJS());
  const listManagementEnabled = useSelector(selectListManagementEnabled)
  const loading = useSelector(selectLoading);
  const prepaidInfoState = useSelector(selectPrepaidCredits);
  const prepaidInfo = prepaidInfoState && typeof prepaidInfoState.toJS === 'function' ? prepaidInfoState.toJS() : (prepaidInfoState || {});

  const validateCVV = (value) => {
    const requiredLength = selectedCard?.cardCVVLength ? selectedCard?.cardCVVLength : 3;

    if (!value) {
      return "CVV is required";
    }

    if (!/^\d+$/.test(value)) {
      return "CVV must contain only numbers";
    }

    if (value.length !== requiredLength) {
      return `CVV must be ${requiredLength} digits`;
    }

    return "";
  };

  const handleCvvChange = (e) => {
  const value = e.target.value;

  // Allow only numbers
  if (!/^\d*$/.test(value)) return;

  setCvv(value);

  // Live validation
  setCvvError(validateCVV(value));
};



  const handleCardChange = (selectedOption) => {
    setSelectedCard(selectedOption);
  };

  const handleClose = ({ cancelled } = {}) => {
    document.body.classList.remove(BODY_CLASS_NAME);
    if (cancelled) onCancel?.();
    closePopup?.();
  };

  const AddPaymentMethod = () => {
    dispatch(AddPaymentPopup.open());
  };

  useEffect(() => {
    document.body.classList.add(BODY_CLASS_NAME);

    const escHandler = e => e.key === 'Escape' && handleClose({ cancelled: true });
     const clickOutside = (e) => {
      // TODO: Fix click outside issue with modal content with better approach
      // if (e.target.closest('.modal-content')) {
      //   return;
      // }

      // if (modalRef.current && !modalRef.current.contains(e.target)) {
      //   handleClose();
      // }
    };

    document.addEventListener('keydown', escHandler, true);
    document.addEventListener('mousedown', clickOutside, true);

    return () => {
      document.removeEventListener('keydown', escHandler, true);
      document.removeEventListener('mousedown', clickOutside, true);
      document.body.classList.remove(BODY_CLASS_NAME);
    };
  }, []);

  const openDNCPolicyModal = () => {
    dispatch(DNCPolicyModal.open())
  }

  const handlereSkipTraceChange = () => {
    setReSkipTrace(val => {
    const mode = "BOTH";
    dispatch(getAppendJobEstimate({
      contactIds,
      appendMode: mode,
      reprocessEnabled: !val
    }))
    return !val;
   })
  }

  const handlePlaceOrder = () => {
  if (isSubmitting || !listName.trim()) return;
    if (appendJob?.newQuantity <= 0) {
         dispatch(InfoAlert.open({
          title: "No Eligible Contacts Found",
          infoText: "Sorry, none of the selected contacts are eligible for Skip Trace. Please select different properties and try again.",
           closePopup: InfoAlert.close()
        }));
    return;
    }

    setIsSubmitting(true);

    // 1. Collect payment data from selectedCard
    const paymentMethodId = selectedCard?.paymentMethodId;
    const cardCode = cvv ? cvv : null;


    const lines = appendJob.lines || [];
    const reprocessEnabled = reSkipTrace;

    // 3. Amounts from summary
    const paymentAmount = appendJob?.total || 0;
    const creditAmount = appendJob?.credits || 0;

    const calculatedRate = appendJob?.total === 0 ? 0 : appendJob?.rate ;

    const {
      rate,
      ...appendJobWithoutRates
    } = appendJob;

    // 4. FINAL CALL (same as old modal)
    const payload = {
      ...appendJobWithoutRates,
      reprocessEnabled,
      lines,
      name: listName,
      rate: calculatedRate,
    };

    const callback = ({ response, statusCode, error }) => {
      if (error) {
        setIsSubmitting(false);
        showToast('Something went wrong and your order wasn’t placed. Please try again.', 'error');
        handleClose();
        return;
    }

    setIsSubmitting(false);
    showToast(
      isPropertySkipTrace
        ? 'Skip Trace completed successfully.'
        : 'Skip Trace in progress. This may take a few minutes — we’ll email you when it’s ready.',
      'success'
    );

    handleClose();
  };

  dispatch(
    isPropertySkipTrace
      ? propertySkipTrace(
          {
            ...payload,
            contactId: contactIds?.[0],
            paymentMethodId,
            cardCode,
            paymentAmount,
            creditAmount,
          },
          response => {
            if (response?.status && response.status !== 'SUCCESS') {
              showToast(response?.message || 'Skip Trace was not completed.', 'error');
              handleClose();
              return;
            }

            showToast('Skip Trace completed successfully.', 'success');
            onSuccess?.();
            handleClose();
          },
          () => {
            showToast('Something went wrong and your order wasn’t placed. Please try again.', 'error');
            handleClose();
          }
        )
      : appendContacts(
          {
            ...payload,
            contactIds,
          },
          paymentMethodId,
          cardCode,
          paymentAmount,
          creditAmount,
          callback
        )
  );
  };

  return (
    <div className={css.modalOverlay}>
      <div className={css.modalWrapper}>
        <div ref={modalRef} className={classNames(css.modalBox, 'modal-content')}>
          <div className={css.modal_header}>{title}</div>

          <div className={css.modal_body}>


            {/* LEFT SIDE */}
            <div className={css.leftCol}>
              <div className={css.list_title}>Name Your List</div>

                 <input
                   type="text"
                   value={listName}
                   placeholder="Enter list name"
                   className={css.input}
                   onChange={(e) => setListName(e.target.value)}
                 />

              <div className={css.checkbox_row}>
                <CheckboxItem
                  label="Re-Skip Trace"
                  checked={reSkipTrace}
                  onChange={() => handlereSkipTraceChange()}
                  labelClassName={css.checkBoxLabelClassName}
                />

                <div className={css.info_wrapper}>
                  <Tooltip
                    title="Re- Skip Trace"
                    description="Rerun previously skip-traced contacts in this list (fees apply). If unchecked, contacts traced in the last 6 months will be suppressed."
                    position="bottom"
                    bgColor="#128292"
                    width={312}
                    xOffset={125}
                    yOffset={-10}
                    arrowOffset={30}
                  >
                    <img src={infoGray} alt="info" className={css.infoIcon} />
                  </Tooltip>
                </div>
              </div>
              <div className={css.orderInfo}>
                Your card is authorized for all selected records, and refunded for any without
                contact info. By clicking “Place Order” you agree to the
                <a target="_blank" href="https://www.propstream.com/terms-of-use" className={css.highlight}> PropStream Terms and Conditions</a>, and
                <span className={css.highlight} onClick={openDNCPolicyModal} > DNC Policy</span>.
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className={css.rightCol}>
              <div className={css.orderBox}>
                {loading && (
                  <div className={css.loadingOverlay}>
                    <SVG icon="spinner" className={classNames(css.mainspinner)} />
                  </div>
                )}
                <div className={css.orderTitle}>Order Details</div>
                <div className={css.orderDetails}>
                  <div className={css.orderRow}>
                    <span>Selected Contacts</span>
                    <span>{selectedProperties ? selectedProperties : contactIds?.length}</span>
                  </div>

                  <div className={css.orderRow}>
                    <span>Eligible Contacts
                      <Tooltip
                        title="Eligible Contacts"
                        description="Some contacts will be omitted if they are duplicates, already Skip Traced, or missing information."
                        position="bottom"
                        bgColor="#128292"
                        width={312}
                        xOffset={125}
                        yOffset={2}
                        arrowOffset={30}
                      >
                        <img src={infoGray} alt="info" className={css.eligibleinfoIcon} />
                      </Tooltip>
                    </span>
                    <span>{appendJob?.newQuantity}</span>
                  </div>

                  <div className={css.orderRow}>
                    <span>Price Per Match</span>
                    <span>${Number(appendJob?.rate ?? 0).toFixed(2)}</span>
                  </div>

                  <div className={classNames(css.orderRow, css.subtotalRow)}>
                    <span>Subtotal</span>
                    <span>${Number(appendJob?.subtotal ?? 0).toFixed(2)}</span>
                  </div>

                  {listManagementEnabled ?
                    <div className={classNames(css.orderRow)}>
                      <span>Free Skip Trace Credits</span>
                      <span>-${Number(appendJob?.freeSkipTraceCredit ?? 0).toFixed(2)}</span>
                    </div> : null
                  }

                  {(!listManagementEnabled && prepaidInfo?.remainingPrepaidCredit) ?
                    <div className={classNames(css.orderRow)}>
                      <span>Prepaid Credits</span>
                      <span>-${Number(appendJob?.prepaidcredits ?? 0).toFixed(2)}</span>
                    </div> : null
                  }

                  <div className={classNames(css.orderRow, css.totalRow)}>
                    <span>Total</span>
                    <span>${Number(appendJob?.total ?? 0).toFixed(2)}</span>
                  </div>
                </div>
              </div>

            {appendJob?.total > 0 &&
              <div className={css.paymentBox}>
                  <div className={css.paymentTitle}>Payment Method</div>

                  <NewCreditCardDropdown
                    tag={false}
                    options={cardList}
                    selectedCard={selectedCard}
                    onChange={handleCardChange}
                    AddPaymentMethod={AddPaymentMethod}
                  />

                  {appendJob?.total > 100 &&
                  <div className={css.cvvWrapper}>
                    <div className={css.cvvInputWrapper}>
                      <input
                        type={cvvVisible ? "text" : "password"}
                        maxLength={4}
                        placeholder="Enter CVV"
                        className={classNames(css.cvvInput, {
                          [css.cvvInputError]: cvvError
                        })}
                        value={cvv}
                        onChange={handleCvvChange}
                        onBlur={() => setCvvError(validateCVV(cvv))}
                      />

                      <img
                        src={cvvVisible ? eyeOpen : eyeClosed}
                        alt="toggle visibility"
                        className={css.cvvToggle}
                        onClick={() => setCvvVisible(v => !v)}
                      />
                    </div>

                    {cvvError && (
                      <div className={css.cvvErrorText}>{cvvError}</div>
                    )}
                    <div className={css.cvvNote}>
                      For your security, please re-enter the CVV for your saved card to complete this purchase
                    </div>
                  </div>
                  }

                  {selectedCard && isCardExpired(selectedCard?.expDate) && (
                    <div className={css.expCardMsg}>Your card has expired. Please use another card.</div>
                  )}

                </div>
             }
            </div>

          </div>

          {/* Footer */}
          <div className={css.modal_footer}>

            <button
              type="button"
              className={classNames(css.btn, css.btn_secondary)}
              onClick={() => handleClose({ cancelled: true })}
            >
              Cancel
            </button>

            <button
              type="button"
              disabled={!listName.trim() || isSubmitting}
              className={classNames(css.btn, css.btn_primary, {
                [css.disabledBtn]: !listName.trim() || isSubmitting
              })}
              onClick={handlePlaceOrder}
            >
            {isSubmitting ? 'Processing...' : 'Place Order'}
            </button>
          </div>
        </div>
      </div>

    </div>
  );
};

const registrationId = getPopupRegistration(SkipTraceModal);
SkipTraceModal.open = (props = {}) =>
  openPopup(registrationId, { ...props, priority: Priority.MEDIUM });
SkipTraceModal.close = () => closePopup({ popup: registrationId });

export default SkipTraceModal;
